/**
 * When inside an iframe (e.g. talentLMS), find Wistia videos and add a link to
 * open the video in a new popup window.
 *
 * While this code runs site-wide, it is specifically being used on
 * documentation pages embeded on talentLMS via iframes.
 */
window._wq=window._wq||[];
(function(){
    function insideIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }
    if (!insideIframe()) return;
    function findWistiaVideoId(elem) {
        // try getting ID from class name
        var classNames = elem.className.split(' ');
        for (var i = 0; i < classNames.length; i++) {
            if (-1 == classNames[i].indexOf('wistia_async_')) continue;
            return classNames[i].replace('wistia_async_' , '');
        }
        // try getting ID from the embed URL
        var parser = document.createElement('a');
        parser.href = elem.getAttribute('src');
        if (parser.pathname && parser.pathname.indexOf('embed/iframe/') > -1) {
            return parser.pathname.split('/').pop();
        }
    }
    var elems = document.querySelectorAll('.wistia_embed'), i, j, name = 'dtm-wistia-embed';
    for (i = 0; i < elems.length; i++) {
        var elem = elems[i];
        var videoId = findWistiaVideoId(elem);
        if (!videoId) continue;
        // create container
        var div = document.createElement('div');
        div.style = "margin-bottom:5px;text-align:right;";
        elem.parentNode.insertBefore(div, elem);
        // create link
        var link = document.createElement('a');
        link.setAttribute('href', 'https://fast.wistia.net/embed/iframe/' + videoId);
        link.setAttribute('target', '_blank');
        link.setAttribute('onclick', "window.open(this.href, '_blank', 'height=720,width=1280');return false;");
        link.appendChild(document.createTextNode('Watch video in a new window'));
        div.appendChild(link);
    }
})();
